import styleguide from '@common/styleguide';
import { FC } from 'react';
import { IconSVG, IconSVGComponentProps } from '../IconComponent';

// This is an especially custom icon: colors are hardcoded. Be careful with
// how / where this is used to ensure it renders as expected.
export const OwnershipJoint: FC<IconSVGComponentProps> = (props) => {
    return (
        <IconSVG viewBox="0 0 20 20" stroke="0" {...props}>
            <g clipPath="url(#a)">
                <rect
                    width="16"
                    height="9"
                    x="2"
                    y="5"
                    fill={styleguide.colors.blue}
                    rx="4.5"
                />
                <circle cx="7.5" cy="9.5" r="1.5" fill="#fff" />
                <circle cx="12.5" cy="9.5" r="1.5" fill="#fff" />
            </g>
            <defs>
                <clipPath id="a">
                    <path fill="#fff" d="M0 0h20v20H0z" />
                </clipPath>
            </defs>
        </IconSVG>
    );
};
